// Base 4 diagnostic questions (12 questions across 5 spheres)
const base4 = [
    // ── I Sfera: Bendroji energija ir savimoka — 3 questions ──
    {
      id: 'q1',
      sphere: 'bendra',
      question: 'Kai prieš mane iškyla didelė ar sudėtinga užduotis:',
      choices: {
        a: 'Susidėlioju aiškų planą žingsnis po žingsnio ir nuosekliai, kantriai jį įgyvendinu.',
        b: 'Užstringu prie smulkmenų ar tobulumo siekio, atidėlioju arba pavargstu dar nepradėjęs.',
        c: 'Susiplanuoju bendrais bruožais, bet leidžiu sau koreguoti eigą pagal aplinkybes.',
      },
    },
    {
      id: 'q2',
      sphere: 'bendra',
      question: 'Kai gyvenime kažkas vyksta ne pagal nusistovėjusią tvarką:',
      choices: {
        a: 'Ramiai prisitaikau ir ją atkuriu – stabilumas man yra vidinė atrama, o ne kalėjimas.',
        b: 'Jaučiu stiprų nerimą ir susierzinimą, nes bet koks netikėtumas išmuša mane iš vėžių.',
        c: 'Šiek tiek sutrinku, bet greitai grįžtu prie įprasto ritmo, kai situacija nusistovi.',
      },
    },
    {
      id: 'q3',
      sphere: 'bendra',
      question: 'Kai galvoju apie taisykles, įsipareigojimus ir duotus pažadus:',
      choices: {
        a: 'Esu patikimas – ką pažadu, tą padarau, ir kiti gali manimi remtis.',
        b: 'Taisykles laikau našta arba, priešingai, įsikabinu į jas taip stipriai, kad prarandu lankstumą.',
        c: 'Įsipareigojimų laikausi, bet pasilieku teisę juos peržiūrėti, jei situacija pasikeičia.',
      },
    },
    // ── II Sfera: Darbas ir karjera — 2 questions ──
    {
      id: 'q4',
      sphere: 'karjera',
      question: 'Kai darbe reikia ilgo, kruopštaus ir nuoseklaus įdirbio:',
      choices: {
        a: 'Tai mano stiprybė – dirbu atkakliai ir užbaigiu pradėtus darbus iki galo.',
        b: 'Greitai pavargstu nuo monotonijos arba persidirbu, nes nemoku sustoti ir pailsėti.',
        c: 'Dirbu sąžiningai, bet stengiuosi rasti balansą tarp darbo ir poilsio.',
      },
    },
    {
      id: 'q5',
      sphere: 'karjera',
      question: 'Kai komandoje reikia kažko, kas suvaldytų procesus ir detales:',
      choices: {
        a: 'Natūraliai prisiimu tvarkos kūrėjo rolę – sudėlioju struktūrą ir sistemą.',
        b: 'Per daug kontroliuoju kiekvieną smulkmeną ir sunkiai patikiu darbus kitiems.',
        c: 'Padedu sutvarkyti svarbiausius dalykus, bet smulkmenas palieku kitiems arba eigai.',
      },
    },
    // ── III Sfera: Santykiai ir partnerystė — 2 questions ──
    {
      id: 'q6',
      sphere: 'santykiai',
      question: 'Kai galvoju apie tai, ko ieškau artimuose santykiuose:',
      choices: {
        a: 'Vertinu ištikimybę, pastovumą ir jausmą, kad galiu kitu žmogumi visiškai pasitikėti.',
        b: 'Per daug kontroliuoju partnerį arba įstringu santykiuose iš baimės keisti tai, kas įprasta.',
        c: 'Ieškau pusiausvyros tarp stabilumo ir laisvės abiem pusėms.',
      },
    },
    {
      id: 'q7',
      sphere: 'santykiai',
      question: 'Kai artimuose santykiuose reikia parodyti jausmus ar švelnumą:',
      choices: {
        a: 'Meilę rodau darbais ir rūpesčiu – esu ta atrama, į kurią galima atsiremti.',
        b: 'Užsisklendžiu, jausmus laikau viduje ir man sunku atvirai juos išreikšti.',
        c: 'Jausmus rodau saikingai – kartais žodžiais, dažniau konkrečiais veiksmais.',
      },
    },
    // ── IV Sfera: Finansai ir resursai — 2 questions ──
    {
      id: 'q8',
      sphere: 'finansai',
      question: 'Kai tvarkau savo pinigus ir kasdienius resursus:',
      choices: {
        a: 'Planuoju nuosekliai, taupau ir kuriu tvirtą finansinį pagrindą ateičiai.',
        b: 'Pernelyg nerimauju dėl pinigų, gailiu sau net būtinų dalykų arba bijau bet kokios rizikos.',
        c: 'Stengiuosi laikytis biudžeto, bet leidžiu sau lankstumą, kai to reikia.',
      },
    },
    {
      id: 'q9',
      sphere: 'finansai',
      question: 'Kai reikia priimti finansinį sprendimą dėl ateities:',
      choices: {
        a: 'Renkuosi patikimumą ir ilgalaikį stabilumą, net jei augimas lėtesnis.',
        b: 'Įstringu neveikime iš baimės suklysti arba laikausi įsikibęs to, kas saugu, net kai jau nebeneša naudos.',
        c: 'Sveriu riziką ir saugumą ir renkuosi protingą vidurio kelią.',
      },
    },
    // ── V Sfera: Savirealizacija ir gyvenimo situacija — 3 questions ──
    {
      id: 'q10',
      sphere: 'savirealizacija',
      question: 'Kai pajuntu, kad mano gyvenimas pernelyg sustabarėjęs ir trūksta pokyčių:',
      choices: {
        a: 'Sąmoningai įsileidžiu šiek tiek naujovių, bet išlaikau tvirtą pagrindą po kojomis.',
        b: 'Lieku įstrigęs įprastoje rutinoje, nes pokyčiai man kelia per didelę baimę.',
        c: 'Po truputį bandau kažką keisti, kai jaučiuosi tam pakankamai saugus.',
      },
    },
    {
      id: 'q11',
      sphere: 'savirealizacija',
      question: 'Kai galvoju apie savo gyvenimo tikslą ir pamatines vertybes:',
      choices: {
        a: 'Žinau, ką statau ir dėl ko dirbu – mano veiksmai turi aiškų pagrindą ir kryptį.',
        b: 'Taip įsitraukiu į kasdienius darbus, kad pamirštu savo gilesnį tikslą ir prasmę.',
        c: 'Turiu bendrą kryptį, bet ją tikslinu pagal tai, ką atneša gyvenimas.',
      },
    },
    {
      id: 'q12',
      sphere: 'savirealizacija',
      question: 'Kai gyvenimas sugriauna mano planus ar tai, ką ilgai kūriau:',
      choices: {
        a: 'Priimu tai kaip pamoką, atsistoju ir kantriai pradedu statyti iš naujo.',
        b: 'Ilgam užstringu praradimo skausme arba įnirtingai laikausi to, ko nebėra.',
        c: 'Pergyvenu, bet pamažu susidėlioju naują planą ir judu toliau.',
      },
    },
  ];

export default base4;
